export default {"src":"/_next/static/media/shadow-image.78c53e15.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};